<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 md11 lg11 xl11>
        <v-layout wrap justify-center py-4 v-if="storage.deliveryAddress">
          <v-flex xs8 text-left align-self-center>
            <span
              style="
                font-family: poppinsmedium;
                font-size: 15px;
                color: #000000;
              "
            >
              ADDRESS
            </span>
          </v-flex>
          <v-flex xs4 text-right align-self-center>
            <v-btn
              small
              outlined
              color="#1fb13b"
              class="text-none"
              @click="printDeliveryAddress"
            >
              <v-icon left small>mdi-printer-outline</v-icon>
              <span style="font-family: opensansbold; font-size: 13px">
                Print
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              {{ storage.deliveryAddress.firstname }}
              {{ storage.deliveryAddress.lastname }}
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              {{ storage.deliveryAddress.streetAddress }},
              {{ storage.deliveryAddress.locality }},
              {{ storage.deliveryAddress.city }},
              {{ storage.deliveryAddress.district }},
              {{ storage.deliveryAddress.state }},
              {{ storage.deliveryAddress.country }},
              {{ storage.deliveryAddress.pincode }}
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <v-layout wrap justify-center py-2>
              <v-flex xs1 align-self-center>
                <v-img
                  src="./../../../assets/icons/phone.svg"
                  height="15px"
                  contain
                ></v-img>
              </v-flex>
              <v-flex xs11 align-self-center>
                <span
                  v-if="storage.deliveryAddress.delphone"
                  style="
                    font-family: opensanssemibold;
                    font-size: 14px;
                    color: #474747;
                  "
                >
                  {{ storage.deliveryAddress.delphone }}
                </span>
                <span v-else>-</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center py-2>
              <v-flex xs1 align-self-center>
                <v-img
                  src="./../../../assets/icons/email.svg"
                  height="15px"
                  contain
                ></v-img>
              </v-flex>
              <v-flex xs11 align-self-center>
                <span
                  v-if="storage.deliveryAddress.email"
                  style="
                    font-family: opensanssemibold;
                    font-size: 14px;
                    color: #474747;
                  "
                >
                  {{ storage.deliveryAddress.email }}
                </span>
                <span v-else>-</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout
          wrap
          justify-center
          py-4
          v-if="storage.shippedService || storage.trackingId"
        >
          <v-flex xs12 text-left>
            <span
              style="
                font-family: poppinsmedium;
                font-size: 15px;
                color: #000000;
              "
            >
              SHIPMENT DETAILS
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-2 v-if="storage.shippedService">
            <span
              style="font-family: poppinslight; font-size: 14px; color: #8d8d8d"
            >
              Service:
            </span>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              {{ storage.shippedService }}
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-1 v-if="storage.trackingId">
            <span
              style="font-family: poppinslight; font-size: 14px; color: #8d8d8d"
            >
              Tracking ID:
            </span>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              {{ storage.trackingId }}
            </span>
          </v-flex>
          <v-flex xs12 pt-4>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs6 text-left>
            <span
              style="
                font-family: poppinsmedium;
                font-size: 15px;
                color: #000000;
              "
            >
              PRICE DETAILS
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 12px; color: #000000"
              v-if="items"
            >
              {{ items.length }} item<span
                v-if="items.length > 1"
                >s
              </span>
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center pt-4>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Total MRP
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Rs.
              <span v-if="storage.actualOrderTotal">
                {{ storage.actualOrderTotal }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Discount Amount
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #2cb194"
            >
              - Rs.
              <span v-if="storage.priceDifference">
                {{ storage.priceDifference.toFixed(2) }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>
        
        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span style="font-family: poppinslight; font-size: 14px; color: #000000">Taxable Amount</span>
          </v-flex>
          <v-flex xs6 text-right>
            <span style="font-family: poppinslight; font-size: 14px; color: #000000">
              Rs. {{ Number(storage.taxableAmount || 0).toFixed(2) }}
            </span>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span style="font-family: poppinslight; font-size: 14px; color: #000000">GST</span>
          </v-flex>
          <v-flex xs6 text-right>
            <span style="font-family: poppinslight; font-size: 14px; color: #000000">
              Rs. {{ Number(storage.taxAmount || 0).toFixed(2) }}
            </span>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-1>
          <v-flex xs6 text-left>
            <span style="font-family: poppinslight; font-size: 13px; color: #8d8d8d; padding-left: 20px;">SGST</span>
          </v-flex>
          <v-flex xs6 text-right>
            <span style="font-family: poppinslight; font-size: 13px; color: #8d8d8d">
              Rs. {{ Number((storage.taxAmount || 0) / 2).toFixed(2) }}
            </span>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-1>
          <v-flex xs6 text-left>
            <span style="font-family: poppinslight; font-size: 13px; color: #8d8d8d; padding-left: 20px;">CGST</span>
          </v-flex>
          <v-flex xs6 text-right>
            <span style="font-family: poppinslight; font-size: 13px; color: #8d8d8d">
              Rs. {{ Number((storage.taxAmount || 0) / 2).toFixed(2) }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Packing Charge
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Rs.
              <span v-if="storage.packingCharge">
                {{ storage.packingCharge }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Delivery Charge
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Rs.
              <span v-if="storage.deliveryCharge">
                {{ storage.deliveryCharge }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>
<!-- 
        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Mode of Delivery
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000; text-transform: capitalize;"
            >
      <span
        v-if="
          items &&
          items.length &&
          items[0].productId &&
          items[0].productId.modeOfDelivery
        "
      >
        {{ items[0].productId.modeOfDelivery }}
      </span>
              <span v-else>-</span>
            </span>
          </v-flex>
        </v-layout> -->

        <v-layout wrap justify-center py-4>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              TOTAL AMOUNT
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              RS.
              <span v-if="storage.orderTotal">
                {{ storage.orderTotal }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>
        <!-- <v-layout wrap justify-center py-4>
          <v-flex xs12>
            <v-btn :ripple="false" depressed block tile color="#FF2323">
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 12px;
                  color: #fff;
                  text-transform: none;
                "
              >
                <span> Continue </span>
              </span>
            </v-btn>
          </v-flex>
        </v-layout> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage", "items"],
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      deliverydate: new Date(),
      user: {
        deliveryaddress: [],
      },
      cart: {},
    };
  },
  methods: {
    printDeliveryAddress() {
      const a = this.storage.deliveryAddress;
      const esc = (v) =>
        String(v == null ? "" : v)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      const name = [a.firstname, a.lastname].filter(Boolean).join(" ");
      const line2 = [a.locality, a.city].filter(Boolean).join(", ");
      const line3 = [a.district, a.state].filter(Boolean).join(", ");
      const line4 = [a.country, a.pincode].filter(Boolean).join(" - ");
      const lines = [a.streetAddress, line2, line3, line4]
        .filter(Boolean)
        .map((l) => "<div>" + esc(l) + "</div>")
        .join("");
      const orderId = this.storage.orderID || this.storage._id || "";
      const html =
        "<!DOCTYPE html><html><head><title>Delivery Address</title>" +
        "<style>" +
        "body{font-family:Arial,sans-serif;margin:0;padding:20px;color:#000;}" +
        ".label{border:2px dashed #000;padding:16px 20px;width:380px;}" +
        ".to{font-size:12px;font-weight:bold;text-transform:uppercase;margin-bottom:6px;}" +
        ".name{font-size:20px;font-weight:bold;margin-bottom:6px;}" +
        ".addr{font-size:16px;line-height:1.5;}" +
        ".phone{font-size:16px;font-weight:bold;margin-top:8px;}" +
        ".order{font-size:12px;margin-top:10px;border-top:1px solid #000;padding-top:6px;}" +
        "@page{margin:10mm;}" +
        "</style></head><body><div class='label'>" +
        "<div class='to'>Delivery Address:</div>" +
        "<div class='name'>" + esc(name) + "</div>" +
        "<div class='addr'>" + lines + "</div>" +
        (a.delphone ? "<div class='phone'>Phone: " + esc(a.delphone) + "</div>" : "") +
        (orderId ? "<div class='order'>Order ID: " + esc(orderId) + "</div>" : "") +
        "</div></body></html>";
      const win = window.open("", "_blank", "width=600,height=500");
      if (!win) {
        alert("Please allow pop-ups to print the address");
        return;
      }
      win.document.open();
      win.document.write(html);
      win.document.close();
      win.focus();
      setTimeout(() => {
        win.print();
        win.close();
      }, 250);
    },
  },
};
</script>
